import React from 'react'
import { DialogContainer } from 'react-md'

const DeleteDialog = ({ visible, onCancelDelete, onConfirmDelete }) => (
  <DialogContainer
    portal
    id='delete-artworks-dialog'
    title='Are you sure you want to delete the selected artworks?'
    visible={visible}
    onHide={onCancelDelete}
    actions={[{
      onClick: onCancelDelete,
      primary: false,
      label: 'Cancel'
    }, {
      onClick: onConfirmDelete,
      primary: true,
      label: 'Confirm'
    }]}
    width={400}
  >
    <p>
      This action cannot be undone. The selected artworks and all its
      associated products will be permanently deleted.
    </p>
  </DialogContainer>
)

export default DeleteDialog



// WEBPACK FOOTER //
// ./src/containers/Artworks/DeleteDialog.js